// The BFF encrypts entity codes and labels each token with a prefix chosen from the field name:
// a rate plan's `providerCode` arrives as `prv_<cipher>`, a creditor's generic `entityCode` as
// `tok_<cipher>`. The cipher part is the same for the same code (the nonce is derived from the
// plaintext), so two tokens name the same entity exactly when their cipher parts match.
// Comparing the whole strings never matched, which left the provider-credit wallet list empty.
const TOKEN_PREFIX = /^[a-z]+_/

function cipherPart(code: string): string {
  return code.replace(TOKEN_PREFIX, '')
}

export function sameEncodedCode(a?: string | null, b?: string | null): boolean {
  if (!a || !b) return false
  return a === b || cipherPart(a) === cipherPart(b)
}
